module.exports = require('./lib/url-builder').default;
module.exports.UrlBuilderContext = require('./lib/url-builder').UrlBuilderContext;
module.exports.UrlBuilder = require('./lib/url-builder').default;
module.exports.default = require('./lib/url-builder').default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@HBKEngineering/url-builder/index.js
// module id = 72
// module chunks = 1